import React from "react";
import styled from "@emotion/styled";
import {
  Label,
  Link,
  LoadingSpinner,
  Select,
  SiteContainer,
  Table,
} from "atoms";
import { Head } from "features/misc";
import { formatDate } from "utils/date";
import { useTicketsByStatus } from "../api/useTickets";
import { Ticket } from "../types";

function AdminTicketList() {
  const [statusFilter, setStatusFilter] = React.useState<string>("new");
  const { isLoading, data } = useTicketsByStatus(statusFilter);

  return (
    <main>
      <Head title="Tickets | QA" />

      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <SiteContainer>
          <Filter>
            <Label>
              Show Tickets with Status:
              <Select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="new">New</option>
                <option value="open">Open</option>
                <option value="closed">Closed</option>
              </Select>
            </Label>
          </Filter>

          <section>
            <Table>
              <thead>
                <tr>
                  <th>Ticket #</th>
                  <th>Created At</th>
                  <th>Project Id</th>
                  <th>Status</th>
                  <th>Category</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((pr: Ticket) => (
                  <tr key={`${pr.id}-${pr.type}`}>
                    <td>
                      <Link to={`/qa/tickets/${pr.id}`}>
                        Ticket #{pr.ticketNumber}
                      </Link>
                    </td>
                    <td>{formatDate(pr.createdAt)}</td>
                    <td>
                      {pr.reviewableType.toLowerCase()}: {pr.reviewableId}
                    </td>
                    <td>{pr.status}</td>
                    <td>{pr.category}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </section>
        </SiteContainer>
      )}
    </main>
  );
}

const Filter = styled.section({
  maxWidth: 400,
  marginBottom: "2rem",
});

export { AdminTicketList };
